import { render, staticRenderFns } from "./ModalApprove.vue?vue&type=template&id=4587d9be&"
import script from "./ModalApprove.vue?vue&type=script&lang=js&"
export * from "./ModalApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports